import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  className?: string;
}

export const TableSkeleton = ({
  rows = 5,
  columns = 5,
  className,
}: TableSkeletonProps) => {
  return (
    <Box className={className} sx={{ width: '100%', py: 1 }}>
      {/* Header Skeleton */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: 'grey.50',
          borderRadius: '12px 12px 0 0',
        }}
      >
        {[...Array(columns)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            height={20}
            sx={{
              flex: 1,
              borderRadius: '6px',
            }}
          />
        ))}
      </Box>

      {/* Rows Skeletons */}
      <Stack spacing={0}>
        {[...Array(rows)].map((_, rowIndex) => (
          <Box
            key={rowIndex}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              p: 2,
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            {[...Array(columns)].map((_, colIndex) => (
              <Skeleton
                key={colIndex}
                variant="rectangular"
                height={16}
                sx={{
                  flex: 1,
                  borderRadius: '4px',
                }}
              />
            ))}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default TableSkeleton;
